import React from 'react'
import Hero from './components/IQAC/Hero';
import Main from './components/IQAC/Main';

const IQAC = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default IQAC;